// @core/api/endpoints/payment/detach_payment_method_from_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/payment';

/**
 * Detach payment method from legal entity
 * Clears the direct legal_entity link on a PaymentMethodDetail. Transitive link via BillingAccount.legal_entity_ref remains if set.
 */
export async function DetachPaymentMethodFromLegalEntity(
  paymentMethodId: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-methods/:paymentMethodId/legal-entity`;
  requestPath = requestPath.replace(':paymentMethodId', encodeURIComponent(paymentMethodId));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
